export default "__VITE_ASSET__477b4448__"